export const INSTALL_LINK_BIGCOMMERCE = 'https://login.bigcommerce.com/app/15924/install';

export const FB_SETTINGS_LINK = 'https://fb.com/settings';
export const FB_SETTINGS_ADD_EMAIL = 'https://www.facebook.com/help/162801153783275';
